import React, {Component} from 'react';

class IconAccount extends Component {
    render() {
        const {color} = this.props;
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="21" viewBox="0 0 17 21">
                <g fill="none" fillRule="evenodd" stroke={color || "#231F20"} strokeWidth="2" transform="translate(0 1)">
                    <path d="M14.987 19.035l.007-2.67a6.5 6.5 0 1 0-12.999-.032l-.006 2.67 12.998.032z"/>
                    <circle cx="8.5" cy="3.5" r="3.5"/>
                </g>
            </svg>
        );
    }
}

export default IconAccount